// extracted by mini-css-extract-plugin
module.exports = {"Report-card-box":"bn","reportCardBox":"bn","report-img-wrap":"bo","reportImgWrap":"bo","report-title":"bp","reportTitle":"bp","report-date":"bq","reportDate":"bq"};